import { render, staticRenderFns } from "./create.vue?vue&type=template&id=2332a242&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2332a242')) {
      api.createRecord('2332a242', component.options)
    } else {
      api.reload('2332a242', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=2332a242&", function () {
      api.rerender('2332a242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/purchase/create.vue"
export default component.exports